import { render, staticRenderFns } from "./Widget13.vue?vue&type=template&id=3d65eb54&"
import script from "./Widget13.vue?vue&type=script&lang=js&"
export * from "./Widget13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports